export default {
  appendKeyframes: function (name, frames) {
    var idx = document.styleSheets[0].cssRules.length
    document.styleSheets[0].insertRule('@keyframes ' + name + ' { ' + frames + ' }', idx)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/services/utils.js
// module id = 80
// module chunks = 0